import { combineReducers } from '@reduxjs/toolkit';

import addonsReducer from './addons/slice';
import customerLibraryReducer from './customerLibrary/slice';
import formatsReducer from './formats/slice';
import layoutsReducer from './layouts/slice';
import panAndZoomReducer from './panAndZoom/slice';
import previewReducer from './preview/slice';
import sidebarReducer from './sidebar/slice';
import templatesReducer from './templates/slice';
import textLibraryReducer from './textLibrary/slice';
import tourReducer from './tour/slice';
import undoRedoReducer from './undoRedo/slice';
import warningsReducer from './warnings/slice';

const editorModulesReducer = combineReducers({
  addons: addonsReducer,
  formats: formatsReducer,
  warnings: warningsReducer,
  panAndZoom: panAndZoomReducer,
  preview: previewReducer,
  sidebar: sidebarReducer,
  undoRedo: undoRedoReducer,
  layouts: layoutsReducer,
  templates: templatesReducer,
  tour: tourReducer,
  textLibrary: textLibraryReducer,
  customerLibrary: customerLibraryReducer,
});

export default editorModulesReducer;
